import { Typography } from '@material-ui/core';

import { HealtheraButton } from '../../../healtheraComponents';
import { Container, Body, Header } from '../../Shared/Table';

import ConsultationsContainer from './ConsultationsContainer';
import { useHistory } from 'react-router';

export default function Consultations() {
  const history = useHistory();

  function addNewConsultation() {
    history.push('/services/consultations/create?type=Consultation');
  }

  return (
    <Container>
      <Header>
        <Typography variant="h4">Consultations</Typography>
        <HealtheraButton onClick={addNewConsultation}>Add new</HealtheraButton>
      </Header>
      <Body>
        <ConsultationsContainer />
      </Body>
    </Container>
  );
}
